import { create } from 'zustand';

interface ConnectivityStore {
  isUnreachable: boolean;
  setReachable: () => void;
  setUnreachable: () => void;
}

export const useConnectivityStore = create<ConnectivityStore>()((set) => ({
  isUnreachable: false,
  setReachable: () => set({ isUnreachable: false }),
  setUnreachable: () => set({ isUnreachable: true }),
}));
